import React from 'react';

import { useAppSelector, useList } from '@pkg/hooks';
import { getFormattedChain } from '@pkg/hooks/tokens/useGetSlugChain';
import { type MarketplaceAsset, type WalletCollectiblesBalance } from '@pkg/types';

import { type CollectionChainType } from '@app/client';

import { OptionsMenu } from './OptionsMenu';

import { ListButton, Wrapper } from './styles';

interface Props {
    nftItem: WalletCollectiblesBalance;
    chain?: CollectionChainType;
    isListed?: boolean;
}

export const NFTManagerControls = ({ nftItem, isListed, chain }: Props) => {
    const marketplaceEnabled = useAppSelector((state) => state.featureFlags.features.marketplaceEnabled);
    const { prepareListing } = useList();

    const handleListButtonClick = () => {
        const splitContract = nftItem.collection.split('.');
        if (nftItem) {
            const asset = {
                tokenId: nftItem.token_id,
                name: nftItem.name,
                collection: {
                    chain: getFormattedChain(splitContract[0]),
                    contractAddress: splitContract[1],
                },
            } as MarketplaceAsset;

            prepareListing(asset);
        }
    };

    const listingMarkup = isListed ? (
        <ListButton $isCancel={true} onClick={handleListButtonClick}>
            Cancel Listing
        </ListButton>
    ) : (
        <ListButton onClick={handleListButtonClick}>List now</ListButton>
    );

    const animation = marketplaceEnabled
        ? {
              initial: { opacity: 0, scale: 0.8, y: 20, x: '-50%' },
              animate: { opacity: 1, scale: 1, y: 0, x: '-50%' },
              exit: { opacity: 0, scale: 0.8, y: 20, x: '-50%' },
          }
        : {
              initial: { opacity: 0, scale: 0.8 },
              animate: { opacity: 1, scale: 1 },
              exit: { opacity: 0, scale: 0.8 },
          };

    return (
        <Wrapper {...animation} $marketplaceEnabled={marketplaceEnabled}>
            {marketplaceEnabled && listingMarkup}

            <OptionsMenu chain={chain} item={nftItem} />
        </Wrapper>
    );
};
